import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/view/Login'
import Home from '../components/view/Home'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js